import { CrossSVG } from '@sbercloud/uikit-product-icons';
import { TEST_IDS } from '../../constants';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function ButtonClose(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: styles.buttonClose,
    onClick: onClick,
    "aria-label": "close drawer",
    "data-test-id": TEST_IDS.closeButton,
    children: /*#__PURE__*/_jsx(CrossSVG, {})
  });
}